import { render } from "./TextReaderSucursal.vue?vue&type=template&id=522cf22b"
import script from "./TextReaderSucursal.vue?vue&type=script&lang=js"
export * from "./TextReaderSucursal.vue?vue&type=script&lang=js"

import "./TextReaderSucursal.vue?vue&type=style&index=0&id=522cf22b&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__